import { DotLegalDialog, DotLegalHeader } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "../../../../localization/useTranslation.ts";
import { Box } from "@mui/material";
import SelectableAnnualWheelActivityTable from "../../../../common/components/selectableAnnualWheelActivityTable/SelectableAnnualWheelActivityTable.tsx";
import { useAnnualWheelActivitySelectorDialog } from "./AnnualWheelActivitySelectorDialog.hooks.ts";

export interface AnnualWheelActivitySelectorDialogProps {
    controlId: string;
    onCloseDialog: () => void;
    onAnnualWheelActivitiesSaved: () => void;
}

function AnnualWheelActivitySelectorDialog(props: AnnualWheelActivitySelectorDialogProps) {
    const { translateString } = useTranslation();
    const { isLoading, selectableAnnnualWheelActivities, onSaveClick, selectedActivities, setSelectedActivities } = useAnnualWheelActivitySelectorDialog(props);

    return (
        <DotLegalDialog
            size={"lg"}
            buttonOkText={translateString("save")}
            open
            onDialogClose={props.onCloseDialog}
            onOkClick={onSaveClick}
            header={translateString("addTaskToControl")}
            okButtonDisabled={selectedActivities.length === 0}
        >
            <Box sx={{ display: "flex", justifyContent: "center" }}>
                <DotLegalHeader center headerStyle={"small"} fontWeight={400} marginBottom={5}>
                    {translateString("selectRelevantTasksForControl")}
                </DotLegalHeader>
            </Box>

            <SelectableAnnualWheelActivityTable
                isLoading={isLoading}
                selectableAnnualWheelActivities={selectableAnnnualWheelActivities}
                selectedAnnualWheelActivities={selectedActivities}
                onAddAnnualWheelActivity={(addedActivity: string) => {
                    let temp = [...selectedActivities];
                    temp.push(addedActivity);
                    setSelectedActivities(temp);
                }}
                onRemoveAnnualWheelActivity={(removedActivity: string) => {
                    let temp = [...selectedActivities];
                    temp = temp.filter((x) => x !== removedActivity);
                    setSelectedActivities(temp);
                }}
                showGroupCompaniesColumn
            />
        </DotLegalDialog>
    );
}

export default AnnualWheelActivitySelectorDialog;
